export const CarnetRoutes = [
  {
    name: 'employee-carnets',
    path: '/employee/carnets',
    component: () => import('@/pages/carnets/Carnets.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

export default CarnetRoutes;
